export const statusConfig: Record<string, { label: string; color: string }> = {
  active: { label: 'ACTIVATED', color: 'bg-[#EFFEF0] text-[#0AA619]' },
  failed: { label: 'FAILED', color: 'bg-[#FEF5EE] text-[#D5441C]' },
  in_progress: { label: 'IN PROGRESS', color: 'bg-[#F3FBFF] text-[#0261B6]' },
  inactive: { label: 'INACTIVE', color: 'bg-red-100 text-red-500' },
};

export const getMetadataFieldLabel = (key: string): string =>
  key
    .split('_')
    .filter(Boolean)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
